import {
  isTerminalPaste,
  isCodeSnippetPaste,
  detectCodeLang,
  terminalPasteBody,
  isWebModelPaste,
} from "./normalizePaste";

function stripHtmlToText(html) {
  return String(html)
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/p>/gi, "\n\n")
    .replace(/<\/h[1-6]>/gi, "\n\n")
    .replace(/<li>/gi, "- ")
    .replace(/<\/li>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/&lt;/gi, "<")
    .replace(/&gt;/gi, ">")
    .replace(/\n{3,}/g, "\n\n")
    .trim();
}

/** Normalize stored content for MarkdownRenderer (markdown, HTML, CLI, LLM). */
export function contentForReading(raw) {
  if (raw == null) return "";
  let s = String(raw).trim();
  if (!s) return "";

  const hasHtml = /<(p|pre|code|h[1-6]|ul|ol|li|img|table|blockquote|div)\b/i.test(s);
  if (hasHtml && !isWebModelPaste(stripHtmlToText(s))) {
    return s;
  }

  if (/^```[\s\S]*```$/m.test(s)) return s;

  if (isTerminalPaste(s)) {
    const body = terminalPasteBody(s) || s;
    return `\`\`\`powershell\n${body}\n\`\`\``;
  }

  if (isCodeSnippetPaste(s)) {
    const lang = detectCodeLang(s) || "";
    return `\`\`\`${lang}\n${s.trim()}\n\`\`\``;
  }

  if (hasHtml) {
    return stripHtmlToText(s);
  }

  return s;
}

export function readingPreview(text = "", max = 140) {
  const md = contentForReading(text);
  const plain = md
    .replace(/```[\s\S]*?```/g, "[código]")
    .replace(/#{1,6}\s+/g, "")
    .replace(/\*\*([^*]+)\*\*/g, "$1")
    .replace(/\[([^\]]+)\]\([^)]+\)/g, "$1")
    .replace(/<[^>]+>/g, "")
    .replace(/\s+/g, " ")
    .trim();
  return plain.length > max ? `${plain.slice(0, max)}…` : plain;
}
